import React, { useState } from "react";
import { motion } from "framer-motion";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Badge } from "@/components/ui/badge";

const portfolioData = [
  {
    id: 1,
    title: "Prestige Woodland Park",
    category: "Living",
    type: "2.5 BHK",
    image: "https://images.unsplash.com/photo-1758448755952-42b404bc6f39?w=800&q=80",
  },
  {
    id: 2,
    title: "Trifecta Bueno",
    category: "Bedroom",
    type: "3 BHK",
    image: "https://images.unsplash.com/photo-1648634158203-199accfd7afc?w=800&q=80",
  },
  {
    id: 3,
    title: "Candeur Signature",
    category: "Kitchen",
    type: "2 BHK",
    image: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?w=800&q=80",
  },
  {
    id: 4,
    title: "Independent House",
    category: "Dining",
    type: "Villa",
    image: "https://images.unsplash.com/photo-1762117360877-2aa74c409f2b?w=800&q=80",
  },
  {
    id: 5,
    title: "Adarsh Serenity",
    category: "Bedroom",
    type: "Villa",
    image: "https://images.unsplash.com/photo-1659986480984-9b7a847168d4?w=800&q=80",
  },
  {
    id: 6,
    title: "Orchid Piccadilly",
    category: "Living",
    type: "3 BHK",
    image: "https://images.unsplash.com/photo-1650532897813-d92427f7d229?w=800&q=80",
  },
  {
    id: 7,
    title: "Elegant Study",
    category: "Study",
    type: "Independent",
    image: "https://images.unsplash.com/photo-1623351143485-b1d4937747f3?w=800&q=80",
  },
  {
    id: 8,
    title: "Traditional Pooja",
    category: "Pooja",
    type: "3 BHK",
    image: "https://images.unsplash.com/photo-1616308913689-cb92c5bea67e?w=800&q=80",
  },
];

const categories = ["All", "Living", "Bedroom", "Kitchen", "Dining", "Study", "Pooja"];

export const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredProjects =
    activeCategory === "All"
      ? portfolioData
      : portfolioData.filter((p) => p.category === activeCategory);

  return (
    <section id="portfolio" className="section bg-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="uppercase tracking-[0.3em] text-[11px] text-muted-foreground mb-4">
            Our Work
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-foreground">
            Our Portfolio
          </h2>
          <p className="mt-4 text-muted-foreground max-w-2xl mx-auto">
            Explore our collection of modern, captivating interiors thoughtfully
            designed for discerning clients.
          </p>
        </motion.div>

        <Tabs defaultValue="All" className="w-full" data-testid="portfolio-tabs">
          <TabsList className="w-full justify-start overflow-x-auto flex-wrap mb-8 bg-muted/50">
            {categories.map((category) => (
              <TabsTrigger
                key={category}
                value={category}
                onClick={() => setActiveCategory(category)}
                data-testid={`portfolio-filter-${category.toLowerCase()}-tab`}
                className="data-[state=active]:bg-[hsl(var(--brand-gold))] data-[state=active]:text-white"
              >
                {category}
              </TabsTrigger>
            ))}
          </TabsList>

          <TabsContent value={activeCategory} className="mt-0">
            <div
              className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
              data-testid="portfolio-grid"
            >
              {filteredProjects.map((project, index) => (
                <motion.div
                  key={project.id}
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                  data-testid="portfolio-card"
                >
                  <div className="group relative aspect-[4/3] overflow-hidden rounded-xl border border-[hsl(var(--border))] bg-muted cursor-pointer">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.8)] via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <h3 className="font-serif-alt text-white text-lg font-semibold mb-1">
                        {project.title}
                      </h3>
                      <Badge variant="secondary" className="bg-[hsl(var(--brand-gold))] text-white">
                        {project.type}
                      </Badge>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default PortfolioSection;
